/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 订单详情页面-记录是否添加到日历接口
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class AddCalendarParams {
  constructor(public isAddCalendar: boolean, public orderId: string) {}
}

export default async function (
  params: AddCalendarParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "patch",
    url: `/order/movie/isAddCalendar`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
